/**
 * marketInsightPanelStore
 *
 * 管理 chat 页面右侧"报告详情面板"的激活状态。
 * - 同一时间只有一个报告详情处于展示状态
 * - 切换报告时，先关闭旧 store 的 isDetailOpen，再激活新 store
 */

import { create } from 'zustand';
import type { createMarketInsightStore } from '../components/ai-msg/market-insight/card/store';

type MarketInsightStoreInstance = ReturnType<typeof createMarketInsightStore>;

interface MarketInsightPanelState {
  /** 当前激活的报告 store 实例，null 表示面板未展开 */
  activeStore: MarketInsightStoreInstance | null;
  /** 激活一个报告详情面板，切换时自动关闭旧的 */
  setActiveStore: (store: MarketInsightStoreInstance) => void;
  /** 关闭面板 */
  closePanel: () => void;
}

const useMarketInsightPanelStore = create<MarketInsightPanelState>((set, get) => ({
  activeStore: null,

  setActiveStore: (store: MarketInsightStoreInstance) => {
    const prev = get().activeStore;
    // 如果切换到不同的 store，先关闭旧的 isDetailOpen
    if (prev && prev !== store) {
      prev.getState().setDetailOpen(false);
    }
    set({ activeStore: store });
  },

  closePanel: () => {
    const prev = get().activeStore;
    if (prev) {
      prev.getState().setDetailOpen(false);
    }
    set({ activeStore: null });
  },
}));

export default useMarketInsightPanelStore;
